export default __webpack_public_path__ + "static/studio-to-sea-1984b193aca4bb11f87a0d3932ab043c.webp";